import React from 'react'
import '../dynamic.css'

const ThinArrowRight = ({h=12,w=12,css=""}) => {
  return (
    <svg className={`thin-arrow-right hidden ${css}`} xmlns="http://www.w3.org/2000/svg" width={w} height={h} viewBox="0 0 12 12" fill="none">
<path d="M0.5 6.00049L11 6.01172M11 6.01172C8.37534 6.40382 6.5 8.14402 6.5 10.0005M11 6.01172C8.36734 5.61962 6.5 3.85695 6.5 2.00049" stroke="black" stroke-width="1.2" stroke-miterlimit="10" stroke-linejoin="bevel"/>
</svg>
  )
}

export default ThinArrowRight
